/**
    品牌列表
**/
<template>
  <div style="width: 1200px;
    margin: auto;">
    <!-- 面包屑导航 -->
    <el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }" class="jj">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/pointMall' }" >积分商城</el-breadcrumb-item>
      <el-breadcrumb-item>{{info.commodity.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row style="margin: 20px 20px 70px;">
         <el-col :span="8">
            <div class="fl">
              <div class="fl second-img" id="secondimg">
                <magnifier :qall='bigphotos' :qallBig='bigphotos'></magnifier>
              </div>
              <div class="smallnav">
                  <ul class="smnav" id="smnav">
                    <li  @click="selectedImg(item,index)" v-for="(item,index) in moreImgArr" :key="item" :class="isSelectedImg==index?'active':''">
                      <el-image :src="`${item}`" alt=""></el-image>
                    </li>
                  </ul>
              </div>
		      	</div>
        </el-col>
        <el-col :span="16">
            <div class="fr second-detail">
                <span class="dettitle">{{info.commodity.name}}</span>
                <div class="pointNumber"><span>{{info.activityPointsNum || 0}}</span> 积分 + <span>{{info.itemDiscountPrice||0}}</span>元</div>
                <el-form  label-width="80px">
                    <el-form-item label="收货地址:">
                        <el-select v-model="address" placeholder="请选择">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <p style="color:#ff6700;cursor:pointer;margin-top:5px;" v-if="options.length==0"  @click="gotoAddress"> 点击此处去添加收货地址  </p>
                    </el-form-item>
                    <el-form-item label="兑换数量 :">
                        <el-input-number v-model="number" @change="handleChange" :min="1" label="描述文字"></el-input-number>
                    </el-form-item>
                    <el-form-item label="">
                        <div class="buygoodsNum">
                            <a href="javascript:;" style="color:white" class="addcar2 fl" id="addcar2"
                                    @click="redeemNow()"
                                    >
                                    <i class="addshopcar"></i>立即兑换</a>
                        </div>
                    </el-form-item>
                </el-form>


			</div>
        </el-col>
    </el-row>
    <el-row>
        <el-col class="goods_advisory" style="background: #ccc;">
            <!-- <shopStoreItem :shopInfo="shopInfo" ></shopStoreItem>
            <hotGoods :navTitle="hotGoodsTitle" :hotGoodsList='lefthotGoodsList'></hotGoods>           -->
            <div style="font-size: 30px;font-weight:bold;padding: 10px;">—— 详情 ——</div>
        </el-col>
        <el-col class="goods_advisory">
            <!-- <shopStoreItem :shopInfo="shopInfo" ></shopStoreItem>
            <hotGoods :navTitle="hotGoodsTitle" :hotGoodsList='lefthotGoodsList'></hotGoods>           -->
            <div v-html="info.commodity.description"></div>
        </el-col>
        <!-- <el-col :span="20">
            <el-tabs class="goodsTabsr_card" type="border-card">
                <el-tab-pane >
                    <span slot="label" class="goodsTabs">商品详情</span>
                        <div class="goods_advisory">
                          <div v-html="info.description"></div>
						</div>
                </el-tab-pane>
                <el-tab-pane>
                    <span slot="label" class="goodsTabs"> 商品评价 <i> ( 0 ) </i></span>
                       <div class="goods_advisory">
                            暂无评价
                       </div>
                </el-tab-pane>
                <el-tab-pane>
                    <span slot="label" class="goodsTabs"> 商品咨询</span>
                        <div class="goods_advisory">
                            <el-input placeholder="请输入内容" v-model="inputContent" class="goods_advisory_input">
                                <el-button slot="append" class="advisory_button" @click="advisoryHandle()">提问</el-button>
                            </el-input>
                        </div>
                </el-tab-pane>
                <el-tab-pane>
                    <span slot="label" class="goodsTabs"> 商家介绍</span>
                        <span>上海宝丽妍贸易有限公司成立于2004年10月09日，注册地位于中国(上海)自由贸易试验区日京路35号凯兴大楼1028室，法定代表人为服部 佑介(HATTORI YUSUKE)。经营范围包括国际贸易、转口贸易、区内企业间的贸易及贸易代理；区内贸易咨询业务；区内商业性简单加工；化妆品、食品、茶叶、饮料、卫生用品、调味品的批发、零售、佣金代理（拍卖除外）、进出口及其它相关配套业务；美容（限分支机构经营），美容管理及相关技术培训、咨询服务。 【依法须经批准的项目，经相关部门批准后方可开展经营活动】上海宝丽妍贸易有限公司具有4处分支机构</span>
                </el-tab-pane>
            </el-tabs>
        </el-col> -->
    </el-row>

    <!-- 提问弹框 -->
    <!-- <el-dialog
      class="addCartBox"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">提问成功</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false"
            >继续浏览</el-button
          >
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog> -->

    <!-- 加入进货单弹框 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="addDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">{{contentTip}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取消</el-button>
          <el-button type="primary" :disabled='isDisabled' @click="confirmExchange">确定</el-button>
        </span>
      </div>
      <!-- <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addDialogVisible = false"
            >确定</el-button
          >
        </span>
      </div> -->
    </el-dialog>
    <!-- 加入进货单结束 -->

    <!-- 浮动窗口开始 -->
	<!-- <div class="windows windowtop" id = "bodytop">
		<div class = "w window_x" >
			<div class="window-goods" >
				<div class="goods-img">
					<img src="images/ls-images/ls-audio/ls-3.jpg" alt="" width="50px">
				</div>
				<div class="goods-title">
					<p>网易云音乐&本来设计 原木创意手机支架手机座扩音器</p>
					<p class="goods-price">¥149</p>
				</div>
			</div>
			<div class="window-buy fr">
				<ul>
					<li class="rightnow"><a href="#">立即购买</a></li>
					<li class="addcar"><a href="#" style="color:white"><i class="addshopcar"></i>加入进货单</a></li>
				</ul>
			</div>
			<div class="canleX" id="canleX">X</div>
		</div>
	</div> -->
	<!-- 浮动窗口结束 -->
  </div>
</template>
<script>
import hotGoods from '@/components/hotGoods'
import shopStoreItem from '@/components/shopStoreItem'
import magnifier from '@/components/magnifier' // 放大镜
// import addressSelect from '@/components/addressSelect'
import '@/assets/css/goodsDetail/goodsDetail.css'
import {commoditylist,addShoppingCart,addresslist,presentlist,immediatePlaceOrder} from "@/api/xunyou";
import $ from 'jquery'
// import
export default {
  data() {
    return {
      isDisabled:false,
      contentTip:'',
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      isSelectedImg:'',
      selected:false,
      selectedImgUrl:'', // 选择的图片路径
      bigphotos:'',
      moreImgArr:[],
      addDialogVisible:false,//加入进货单弹框
      goodsSize:5,
      info:{},
      address:'',
      number:1,
      options: [], // 收货地址
      centerDialogVisible: false,
      successInfo: true,
      inputContent:'',
    };
  },
  // 注册组件
  components: {hotGoods,shopStoreItem,magnifier},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
    this.getCommoditylistDetail();
    if(this.userInfo.userId){
      this.getAddressList();
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    gotoAddress(){
      if(this.userInfo.userId){
        this.$router.push('/address')
      }else{
        this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },1000)
            return
      }
    },

     //   选择的图片
    selectedImg(url,index){
        this.selected = true;
        this.isSelectedImg = index;
        this.selectedImgUrl = url
        this.bigphotos = url
    },

    // 查询收货地址列表
    getAddressList(){
      this.options = []
        addresslist({muid:this.userInfo.userId||''})
          .then(res => {
          if (res.code == 0) {
            res.rows.forEach(element => {
              const obj = {}
              obj.value = element.said
              obj.label =`${element.areaName} ${element.address}`
              this.options.push(obj)
            });
              // this.options = res.rows
          } else {
              this.$message({
              type: 'info',
              message: res.msg
              })
          }
          })
          .catch(err => {
             this.$message.error('查询收货失败，请稍后再试！')
          })
    },

    // 商品详情查询
    getCommoditylistDetail() {
      this.loading = true;
      presentlist({
        id: this.$route.query.id,
        specificationId: this.$route.query.specificationId,
        mallUserId:this.userInfo.userId || ''
        })
        .then((res) => {
          //   if (res.code == 0) {
          console.log("res", res);
          this.loading = false;
          this.info = res.rows[0];
          this.moreImgArr = res.rows[0].commodity.more_photos!=null&&res.rows[0].commodity.more_photos!=''?res.rows[0].commodity.more_photos.split(','):res.rows[0].commodity.photos.split(',');
          this.bigphotos = this.moreImgArr[0]!=null?this.moreImgArr[0]:'';
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询商品列表失败，请稍后再试！");
        });
      // commoditylist({id: this.$route.query.id})
      //   .then((res) => {
      //     //   if (res.code == 0) {
      //     console.log("res", res);
      //     this.loading = false;
      //     this.info = res.rows[0];
      //     this.moreImgArr = res.rows[0].more_photos!=null&&res.rows[0].more_photos!=''?res.rows[0].more_photos.split(','):[];
      //     this.bigphotos = this.moreImgArr[0]!=null?this.moreImgArr[0]:'';
      //   })
      //   .catch((err) => {
      //     this.editFormVisible = false;
      //     this.loading = false;
      //     this.$message.error("查询商品列表失败，请稍后再试！");
      //   });
    },

    // 选规格价格发生变化
    getgoodsSize(value,updateprice){
      // this.info.price = value*this.info.number;
      // this.updateprice = updateprice;

    },

    // 计数量
     handleChange(value) {
      console.log(value);
      // this.info.marketprice = value*this.info.marketprice;

    },

    // 立即兑换
    redeemNow(){
      if(this.userInfo.loginName==null||this.userInfo.loginName=="" ){
          this.$router.push('/login')
          return
        }
      if(this.address == ''){
        this.$message.error("请选择收货地址");
      }else{
        this.contentTip = '确认兑换'
        this.addDialogVisible = true

      }
    },

    // 确认兑换 （直接下单）
    confirmExchange(){
      this.isDisabled = true
     const req = {
       bxmId: this.info.commodity.mid, // 店铺id
       muid: this.userInfo.userId || '' , // 用户Id
       redPay: 0,
       rid: "",
       title: this.info.commodity.name, // 订单的标题
       amount: this.info.itemDiscountPrice, // 实际付款金额
       said: this.address, // 收货地址id
       id: this.info.commodity.id,  // 商品id
       number: this.number, // 商品数量
       bxysid: this.info.specificationid,
       pointfee: this.info.activityPointsNum,
       transpotfee: 0,
       goodsfee: this.info.itemDiscountPrice || 0, // 商品价格
       commodityType:1, //商品用的活动价购买，立刻下单的接口多传一个参数 commodityType，值传1
       bXyInvoice: {
          type: '',
          attribution: '',
          invoiceTitle: "",
          code: ""
        }
      }
      // 1.兑换成功 弹框关闭，2.失效，更改弹框内容
      // const req = {
      //   muid:this.userInfo.userId || '' , // 用户Id
      //   scid:'', // 进货单id
      //   shopInfo:[
      //     {
      //       amount: this.info.itemDiscountPrice, // 实际付款金额
      //       bxmId: this.info.commodity.mid, // 店铺id
      //       discountOffer: "",
      //       redPay: 0, // 红包折扣
      //       point:this.info.activityPointsNum,
      //       said: this.address, // 收货地址id
      //       title: this.info.commodity.name, // 订单的标题
      //       type: 1, // 默认在线支付为1
      //       goodsList:[{
      //         bxysid: 0, // 属性id
      //         id: this.info.commodity.id,  // 商品id
      //         number: this.number, // 商品数量
      //         realprice: this.info.itemDiscountPrice || 0 // 商品价格
      //       }]
      //     }
      //   ]
      // }
      immediatePlaceOrder(req)
        .then((res) => {
          if (res.data.code == 0) {
            // if(res.data.data[0].amount!=0){
              sessionStorage.setItem("orderGoodsInfo", JSON.stringify(res.data.data));
              this.isDisabled = false
              this.$message({
                  type: 'success',
                  message: res.data.msg
                  })
                  this.$router.push('/orderNow');
            // }else{
            //   this.$router.push('/myOrderRight');
            // }
          } else {
            // this.contentTip = '积分兑换活动已失效！'
            this.contentTip = res.data.msg
            this.addDialogVisible = true
            this.isDisabled = false
              this.$message({
              type: 'info',
              message: res.data.msg
              })
          }
        })
        .catch(err => {
          this.$message.error('下单失败，请稍后再试！')
        })

    }
  },
};
</script>

<style lang="less" scoped >
.breakcrumbHeader{
   margin:15px 0;
}
.bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

span.dettitle {
    // color: #d33a31;
    line-height: 20px;
    font-weight: bold;
}

.dettitle{
    font-weight: bold;
}
img#smallBox_img {
    width: 440px;
    height: 440px;
}
.second-img{
    border: 1px solid #eaeaea;
}
.pointNumber {
    font-size: 16px;
    padding: 15px 0 25px 0;
    border-bottom: 1px solid #c9c9c9;
    margin-bottom: 35px;
    span{
            font-weight: 700 !important;
            color: #e13c41;
            font-size: 30px;
    }
    i{
        margin-left: 20px;
        color: #888888;
        text-decoration: line-through;
    }
}
//   规格按钮
.second-detail{
     /deep/.el-radio.is-bordered.is-checked {
        border-color: #d33a31;
    }
    /deep/.el-radio__input.is-checked+.el-radio__label {
        color: #d33a31;
    }
    /deep/.el-radio__input.is-checked .el-radio__inner {
        border-color: #d33a31;
        background: #d33a31;
    }
}


/* 商品Tabs项 */
  .goodsTabs{
      font-size: 14px;
  }
.goodsTabsr_card{
    /deep/.el-tabs__item{
        color: #555555;
    }
    /deep/.el-tabs__item.is-top.is-active {
        color: white !important;
        background-color: #e4393c !important;
        border-right-color: #e4393c !important;
        border-left-color: #e4393c !important;
    }
    /deep/.el-tabs__header {
        background-color: #ddd;
        border-bottom: 2px solid #e4393c;

    }
    /deep/.el-tabs__content {
        min-height: 500px;
        background: #f8f8f8;
    }
}

  /* 商品咨询 */
  .goods_advisory {
    text-align: center;
    // /deep/img{
    //   width: 100% !important;
    // }
}
  .goods_advisory_input{
      width: 50%;
  }
 .advisory_button {
    background: #e4393c !important;
    border: 1px solid #e4393c !important;
    color: white !important;
    border-radius: 0;
}

/* 提问狂 */
.dialog-footer {
  margin-top: 20px;
  display: block;
}
.addGoodsInfo {
  font-size: 24px;
}
.addCartBox .el-button--primary {
  color: #fff;
  background-color: #ff6700;
  border-color: #e65d00;
}


</style>







// WEBPACK FOOTER //
// src/views/pointMall/pointsProDetails.vue